import { render, staticRenderFns } from "./details.vue?vue&type=template&id=583eedd2&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=583eedd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583eedd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583eedd2')) {
      api.createRecord('583eedd2', component.options)
    } else {
      api.reload('583eedd2', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=583eedd2&scoped=true&", function () {
      api.rerender('583eedd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/refundAudit/details.vue"
export default component.exports